import { useQuery } from '@hooks/reactQuery';

import { getOptionsCells } from '@api/kpi';

import { ETechnologiesValues, EUserRoles, EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { OPTIONS_T_4G_FDD_NOKIA, OPTIONS_T_4G_TDD_NOKIA, OPTIONS_T_5G_NOKIA } from '@constants/queryKeys';

interface IUseQueryOptionsCellsNokiaProps {
	isKpiView: boolean;
	availableVendors: string[];
}

export const useQueryOptionsCellsNokia = (props: IUseQueryOptionsCellsNokiaProps) => {
	const { isKpiView, availableVendors } = props;
	const isNokiaVendor = availableVendors.includes(EVendorsValues.nokia);

	const {
		data: options4GTddNokia,
		isInitialLoading: isLoadingOptions4GTddNokia,
	} = useQuery({
		queryKey: [OPTIONS_T_4G_TDD_NOKIA],
		queryFn: () => getOptionsCells({
			technology: ETechnologiesValues.T_4G_TDD,
			vendor: EVendorsValues.nokia,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isNokiaVendor],
		...refetchOptions,
	});

	const {
		data: options4GFddNokia,
		isInitialLoading: isLoadingOptions4GFddNokia,
	} = useQuery({
		queryKey: [OPTIONS_T_4G_FDD_NOKIA],
		queryFn: () => getOptionsCells({
			technology: ETechnologiesValues.T_4G_FDD,
			vendor: EVendorsValues.nokia,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isNokiaVendor],
		...refetchOptions,
	});

	const {
		data: options5GNokia,
		isInitialLoading: isLoadingOptions5GNokia,
	} = useQuery({
		queryKey: [OPTIONS_T_5G_NOKIA],
		queryFn: () => getOptionsCells({
			technology: ETechnologiesValues.T_5G,
			vendor: EVendorsValues.nokia,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isNokiaVendor],
		...refetchOptions,
	});

	return {
		options4GTddNokia,
		isLoadingOptions4GTddNokia,
		options4GFddNokia,
		isLoadingOptions4GFddNokia,
		options5GNokia,
		isLoadingOptions5GNokia,
	};
};
